export const events = {
  SELECT_CITY_ON_MAP: "city_map_pin_click",
  SELECT_LISTING_ON_MAP: "listing_map_impression",
  OPEN_LISTING_DETAILS_ON_MAP: "OPEN_LISTING_DETAILS_ON_MAP",
  TOGGLE_LISTINGS_VIEW_MODE_ON_MAP: "change_map_view",
  START_DRAW_ON_MAP: "start_draw_on_map",
  CANCEL_DRAW_ON_MAP: "cancel_draw_on_map",
  TOGGLE_MAP_TYPE: "change_map_type",
  USER_LOADED: "user_loaded",
  USER_LOGIN: "login",
  ADD_NEW_LISTING: "add_new_listing_click",
  SHOW_POPUP_SERVICE: "show_services_popup",
  CLOSE_POPUP_SERVICE: "close_services_popup",
  VIEW_LISTING_LIST: "view_listing_list",
  LISTING_MAP_PIN_IMPRESSION: "listing_map_pin_impression",
  CHANGE_LISTING_LIST_VIEW: "change_listing_list_view",
  OPEN_LISTING_LIST_FILTERS: "open_listing_list_filters",
  CHANGE_LISTING_CATEGORY: "change_listing_list_category",
  VIEW_LISTING: "view_listing",
  VIEW_LISTING_IMAGE: "view_listing_image",
  GET_LISTING_PHONE: "get_listing_phone",
  ADD_LISTING_TO_FAVORITE: "add_listing_to_favorites",
  OPEN_SHARE_LISTING_MODAL: "open_share_listing_popup",
  SHARE_LISTING: "share_listing",
  SHOW_USER_MENU: "show_user_menu",
  CLOSE_USER_MENU: "close_user_menu",
  OPEN_NOTIFS: "open_notifs",
  OPEN_USER_PROFILE: "open_user_profile",
  OPEN_REQUESTS: "open_requests",
  CLICK_SIMILAR_LISTING: "open_similar_listing",
  OPEN_FAVED_LISTINGS: "open_faved_listings",
  TOGGLE_FAV_LISTINGS: "toggle_fav_listings",
  OPEN_CONTACT_US: "open_contact_us",
  TOGGLE_CONTACT_US: "toggle_contact_us",
  SUBMIT_CONTACT_US: "submit_contact_us",
  USER_LOGOUT: "logout",
  OPEN_BUILDING_CALCULATOR: "open_building_calculator",
  OPEN_ADD_FEATURED: "open_add_featured",
  OPEN_SERVICES: "open_services",
  OPEN_RENT_CONTRACTS: "open_rent_contracts",
  OPEN_STATS: "open_stats",
  OPEN_CONSTRUCTION: "open_construction",
  OPEN_REPORT_LISTING_MODAL: "open_report_listing_modal",
  SUBMIT_LISTING_REPORT: "submit_listing_report",
  OPEN_PROPERTY_REGISTRATION: "open_property_registration",
  OPEN_SURVEYING_PROPERTY: "open_surveying_property",
  OPEN_LISTING_FEE: "open_listing_fee",
  DAILY_RENT_RESERVE: "daily_rental_reserve_button",
  DAILY_RENT_START: "open_daily_dates",
  RED_MODE: "red_mode",
  DAILY_RENT_PAY: "daily_rental_payment_button",
  DAILY_RENT_CHANGE_FILTER: "daily_rental_change_filter",
  DAILY_RENT_SET_DATE: "set_daily_dates",
  OPEN_SEARCH: "open_search",
  DAILY_RENT_CHAT: "daily_rental_chat_button",
  ADD_NEW_LICENSED_LISTING: "add_new_licensed_listing_click",
  ADD_LICENSING_REQUEST_BY_AQAR: "add_licensing_request_by_aqar",
  ADD_MARKETING_REQUEST_EVENT: "add_marketing_request",
  CLICK_ON_ALJAZIRA_FROM_SERVICES: "click_on_aljazira_from_services",
  CLICK_ON_ALRAJHI_FROM_SERVICES: "click_on_alrajhi_from_services",
  CLICK_WHATSAPP_BUTTON: "whatsapp_owner",
  GENERIC_CTA_CLICK: "click_interaction",
  APPLY_SEARCH: "apply_search",
  LOCATION_CHANGE: "change_location",
  SET_SEARCH_PARAM: "set_search_param",
  CONTACT_USER: "contact_user",
  VIDEO_START: "video_start",
  REPORT_ITEM: "report_item",
  SHARE_ITEM: "share_item",
  USER_SIGNUP: "sign_up",
  CATEGORY_CHANGE: "category_change",
  RESET_SEARCH: "reset_search",
};

/**
 * @typedef {Object} ListingType
 * @property {string} SALE - Represents a sale listing
 * @property {string} RENT - Represents a rent listing
 * @property {string} DAILY - Represents a daily listing
 */

/** @type {ListingType} */
export const LISTING_TYPE = {
  SALE: "sale",
  RENT: "rent",
  DAILY: "daily",
  ALL: "all",
};
